/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
import $, { speed } from 'jquery';
import prestashop from 'prestashop';
// eslint-disable-next-line
import updateSources from './components/update-sources';
import ProductMinitature from './components/product-miniature';

$(document).ready(() => {
  const productConfig = (qv) => {
    $(prestashop.themeSelectors.product.thumb).on('click', (event) => {
      // Swap active classes on thumbnail
      if ($(prestashop.themeSelectors.product.thumb).hasClass('selected')) {
        $(prestashop.themeSelectors.product.thumb).removeClass('selected');
      }
      $(event.currentTarget).addClass('selected');

      // Get data from thumbnail and update cover src, alt and title
      $(prestashop.themeSelectors.product.cover).attr('src', $(event.target).data('image-large-src'));
      $(prestashop.themeSelectors.product.cover).attr('alt', $(event.target).attr('alt'));
      $(prestashop.themeSelectors.product.cover).attr('title', $(event.target).attr('title'));

      // Get data from thumbnail and update cover sources
      updateSources(
        $(prestashop.themeSelectors.product.cover),
        $(event.target).data('image-large-sources'),
      );
    });
    qv.find(prestashop.selectors.quantityWanted).TouchSpin({
      verticalbuttons: true,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: 1,
      max: 1000000,
    });

    $(prestashop.themeSelectors.touchspin).off('touchstart.touchspin');
  };

  $('body').on(
    'click',
    prestashop.themeSelectors.listing.searchFilterToggler,
    () => {
      $(prestashop.themeSelectors.listing.searchFiltersWrapper).removeClass(
        'd-none d-md-block',
      );
      $(prestashop.themeSelectors.contentWrapper).addClass('d-none d-md-block');
      $(prestashop.themeSelectors.footer).addClass('d-none d-md-block');
    },
  );
  $(
    `${prestashop.themeSelectors.listing.searchFilterControls} ${prestashop.themeSelectors.clear}`,
  ).on('click', () => {
    $(prestashop.themeSelectors.listing.searchFiltersWrapper).addClass(
      'd-none d-md-block',
    );
    $(prestashop.themeSelectors.contentWrapper).removeClass('d-none d-md-block');
    $(prestashop.themeSelectors.footer).removeClass('d-none d-md-block');
  });
  $(`${prestashop.themeSelectors.listing.searchFilterControls} .ok`).on(
    'click',
    () => {
      $(prestashop.themeSelectors.listing.searchFiltersWrapper).addClass(
        'd-none d-md-block',
      );
      $(prestashop.themeSelectors.contentWrapper).removeClass('d-none d-md-block');
      $(prestashop.themeSelectors.footer).removeClass('d-none d-md-block');
    },
  );

  const parseSearchUrl = function (event) {
    if (event.target.dataset.searchUrl !== undefined) {
      return event.target.dataset.searchUrl;
    }

    if ($(event.target).parent()[0].dataset.searchUrl === undefined) {
      throw new Error('Can not parse search URL');
    }

    return $(event.target).parent()[0].dataset.searchUrl;
  };

  function updateProductListDOM(data) {
    $(prestashop.themeSelectors.listing.searchFilters).replaceWith(
      data.rendered_facets,
    );
    $(prestashop.themeSelectors.listing.activeSearchFilters).replaceWith(
      data.rendered_active_filters,
    );
    $(prestashop.themeSelectors.listing.listTop).replaceWith(
      data.rendered_products_top,
    );

    const renderedProducts = $(data.rendered_products);
    const productSelectors = $(prestashop.themeSelectors.listing.product);

    if (productSelectors.length > 0) {
      productSelectors.removeClass().addClass(productSelectors.first().attr('class'));
    } else {
      productSelectors.removeClass().addClass(renderedProducts.first().attr('class'));
    }

    $(prestashop.themeSelectors.listing.list).replaceWith(renderedProducts);

    $(prestashop.themeSelectors.listing.listBottom).replaceWith(
      data.rendered_products_bottom,
    );
    if (data.rendered_products_header) {
      $(prestashop.themeSelectors.listing.listHeader).replaceWith(
        data.rendered_products_header,
      );
    }

    const productMinitature = new ProductMinitature();
    productMinitature.init();
  }

  const initSliderSubcategories = new Swiper('#subcategories .swiper', {
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: 20,
    centeredSlides: false,
    centerInsufficientSlides: true,
    loop: false,
    speed: 1000,
    autoplay: {
      delay: 2000,
      pauseOnMouseEnter: true,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 6,
        slidesPerGroup: 3
      },
    },
  });

  const initSliderFeaturedProducts = new Swiper('.js-featured-products', {
    slidesPerView: 2,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1260: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1680: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });

  $('body').on(
    'change',
    `${prestashop.themeSelectors.listing.searchFilters} input[data-search-url]`,
    (event) => {
      prestashop.emit('updateFacets', parseSearchUrl(event));
    },
  );

  $('body').on(
    'click',
    prestashop.themeSelectors.listing.searchFiltersClearAll,
    (event) => {
      prestashop.emit('updateFacets', parseSearchUrl(event));
    },
  );

  $('body').on('click', prestashop.themeSelectors.listing.searchLink, (event) => {
    event.preventDefault();
    prestashop.emit(
      'updateFacets',
      $(event.target)
        .closest('a')
        .get(0).href,
    );
  });

  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.current_url) {
      window.location.href = e.state.current_url;
    }
  });

  $('body').on(
    'change',
    `${prestashop.themeSelectors.listing.searchFilters} select`,
    (event) => {
      const form = $(event.target).closest('form');
      prestashop.emit('updateFacets', `?${form.serialize()}`);
    },
  );

  $('.quantity-input').TouchSpin({
    verticalbuttons: false,
    verticalupclass: 'material-icons touchspin-up',
    verticaldownclass: 'material-icons touchspin-down',
    buttondown_class: 'btn btn-touchspin js-touchspin',
    buttonup_class: 'btn btn-touchspin js-touchspin',
    buttondown_txt: '<i class="sld-icon-minus"></i>',
    buttonup_txt: '<i class="sld-icon-plus"></i>',
    min: 1,
  });

  const ajaxAddToCart = () => {
    if (prestashop.configuration.is_catalog === false) {
      $('body').on('click', '.js-ajax-add-to-cart', function (event) {
        event.preventDefault();
        const $btn = $(this);
        $btn.addClass('disabled');
        const actionURL = prestashop.urls.pages.cart;
        const productId = `id_product=${$btn.data('id-product')}`;
        const productIdAttribute = $btn.data('id-product-attribute');
        const idProductAttribute = (typeof productIdAttribute !== 'undefined') ? productIdAttribute : 0;
        const quantityInput = document.querySelector(`#quantity-input-${$btn.data('id-product')}-${productIdAttribute}`);
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        const token = `token=${prestashop.static_token}`;
        const query = `${productId}&id_product_attribute=${idProductAttribute}&add=1&action=update&${token}&qty=${quantity}`;
        $.post(actionURL, query, null, 'json').then((resp) => {
          prestashop.emit('updateCart', {
            reason: {
              idProduct: resp.id_product,
              idProductAttribute: resp.id_product_attribute,
              linkAction: 'add-to-cart',
            },
            resp,
          });
          $btn.removeClass('disabled');
        }).fail((resp) => {
          prestashop.emit('handleError', {eventType: 'addProductToCart', resp});
        });

        return false;
      });
    }
  };

  const stickyProductFilters = () => {
    const original = document.getElementById('js-product-filters');
    const stickyContainer = document.getElementById('js-product-filters-sticky');
    const header = document.getElementById('header');

    // Vérifie si on est sur desktop et si les éléments existent
    if (!original || !stickyContainer || !header || window.innerWidth < 992) return;

    // Hauteur du header fixed
    const headerHeight = header.offsetHeight;

    // Créer un placeholder pour conserver l'espace
    const placeholder = document.createElement('div');

    const toggleSticky = (isVisible) => {
        if (isVisible) {
            stickyContainer.classList.remove('active');
            // Remettre le contenu dans original si nécessaire
            while (stickyContainer.firstChild) {
                original.appendChild(stickyContainer.firstChild);
            }
            if (placeholder.parentNode === original) {
                original.removeChild(placeholder);
            }
        } else {
            stickyContainer.classList.add('active');
            // Ajouter placeholder si absent
            if (placeholder.parentNode !== original) {
                placeholder.style.height = `${original.offsetHeight}px`;
                original.appendChild(placeholder);
            }
            // Déplacer tout le contenu de original vers stickyContainer
            while (original.firstChild && original.firstChild !== placeholder) {
                stickyContainer.appendChild(original.firstChild);
            }
        }
    };

    // Observer pour détecter la visibilité du bloc original
    const observer = new IntersectionObserver(
        (entries) => {
            toggleSticky(entries[0].isIntersecting);
        },
        {
            threshold: 0,
            // rootMargin: `-${headerHeight}px 0px 0px 0px` // décalage pour header fixed
        }
    );

    observer.observe(original);
  };

  const stickyBackToTop = () => {
    const backToTopBtn = document.getElementById('js-product-filters-back-to-top');
    const productFilters = document.getElementById('js-product-filters');

    if (!backToTopBtn || !productFilters) return;

    backToTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // IntersectionObserver observe quand "js-product-filters" sort de la vue
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting) {
          backToTopBtn.classList.remove('visible');
        } else {
          backToTopBtn.classList.add('visible');
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px',
      }
    );

    observer.observe(productFilters);    
  };

  ajaxAddToCart();
  // stickyProductFilters();
  stickyBackToTop();

  prestashop.on('updateProductList', (data) => {
    updateProductListDOM(data);
    window.scrollTo(0, 0);
    // stickyProductFilters();
  });
});
